<template>
    <teleport to="#modal">
        <Loading
            :visible="loading"
        >
        </Loading>
    </teleport>
    <div id="selectModal"></div>
    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto pt-3">
            <Alert v-if="save_error" class="bg-next-orange mb-5 sticky top-0 z-50">Non è stato possibile effettuare il salvataggio,
                correggi gli errori.
            </Alert>
            <div class="py-10 flex justify-between">
                <Breadcrumbs :paths="paths"></Breadcrumbs>
                <div class="flex">
                    <NextButton variant="outline-secondary" @click="$router.back()"
                                class="w-48 hidden text-sm sm:block py-2 px-4">
                        &lt; Indietro
                    </NextButton>
                    <NextButton variant="primary" @click="save"
                                class="w-48 text-sm sm:block py-2 px-4 ml-3">Salva <i class="spinner"></i>
                    </NextButton>

                </div>
            </div>
            <h1 class="font-bold text-xl mb-3">Termini di pagamento progetti</h1>

            <div class="max-w-screen-2xl m-auto grid grid-cols-1 gap-3 pb-8">
                <div v-for="(b,i) in form_data" :key="i" class="border border-next-gray rounded p-3">

                    <div class="flex flex-col">
                        <Field field_name="Termini di pagamento">
                            <VueMultiselect
                                v-model="b.termine_pagamento"
                                :options="terminiDiPagamentoAutocomplete.options"
                                placeholder="Scegli termine di pagamento"
                                class="next-vue-multiselect-single"
                                track-by="id"
                                label="descrizione"
                                selectLabel=""
                                deselectLabel=""
                                selectedLabel=""
                                :internal-search="false"
                                @search-change="terminiDiPagamentoAutocomplete.search"
                            >
                            </VueMultiselect>
                        </Field>
                    </div>

                    <div class="flex flex-col pt-3">
                        <Field :field_name="b.azienda_gruppo_nome" :errors="getErrors(i,'termini_condizioni')">
                            <textarea class="p-3 border-next-gray-md-dark border-2 w-full" rows="2"
                                      v-model="b.termini_condizioni"></textarea>
                        </Field>
                    </div>

                </div>
            </div>
        </div>
    </div>

</template>
<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import Loading from "@/components/Loading.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import NextButton from "@/components/NextButton.vue";
import Field from "@/components/Field.vue";
import clientiManager from "../api/Clienti";
import Alert from "@/components/Alert.vue";
import Autocomplete from "@/setup/Autocomplete";
import terminiPagamentoManager from "../api/TerminiPagamento";
import DynamicCell from "@/components/DynamicCell.vue";
import {aziendeGruppoManager} from "../api/AziendeGruppo";


@Options({
    name: 'TerminiCliente',
    components: {
        DynamicCell,
        Alert,
        Field,
        NextButton,
        Breadcrumbs,
        Loading

    },
    props: {
        id: [String, Number]
    }
})
export default class TerminiCliente extends Vue {

    id!: string | number
    loading = false
    save_error = false

    aziendeGruppo: any[] = []
    termini: any[] = []
    errors = {}
    form_data: any[] = []
    terminiDiPagamentoAutocomplete: any = setup(() => Autocomplete(terminiPagamentoManager))


    created() {
        this.terminiDiPagamentoAutocomplete.search('', 0)
        Promise.all([
            aziendeGruppoManager.list({t:1}),
            clientiManager.terminiBusinessUnits(this.id)
        ]).then(([az, term]) => {
            this.aziendeGruppo = az.data.data
            this.termini = term.data
            this.aziendeGruppo.forEach((az) => {
                this.form_data.push({
                    azienda_gruppo_id: az.id,
                    azienda_gruppo_nome: az.nome,
                    termine_pagamento: this.termini.find((e) => e.azienda_gruppo_id == az.id)?.termine_pagamento,
                    termini_condizioni: this.termini.find((e) => e.azienda_gruppo_id == az.id)?.termini_condizioni
                })
            })
        })
    }

    getErrors(index: string | number, field: string) {
        return (this.errors as any)[`data.${index}.${field}`]
    }

    save() {
        this.save_error = false
        this.loading = true
        clientiManager.createTermini(this.id, {
            data: this.form_data.map((e: any) => {
                return {
                    azienda_gruppo_id: e.azienda_gruppo_id,
                    termine_pagamento_id: e.termine_pagamento?.id || null,
                    termini_condizioni: e.termini_condizioni || null
                }
            })
        }).catch((res) => {
            if (res.response.status == 422) {
                this.errors = res.response.data.errors
            } else {
                this.save_error = true
            }
        }).finally(() => {
            this.loading = false
        })
    }

    get paths() {
        return [
            {
                title: 'Home',
                name: 'Dashboard',
            },
            {
                title: 'Anagrafica',
                name: 'DettaglioAzienda',
                params: {id: this.id}
            },
            {
                title: 'Termini di pagamento',
                name: 'TerminiCondizioni',
            },
        ]
    }
}
</script>


<style lang="scss">

</style>
